import { getCWRedirectUrl } from "utils/helper";

const STEPS_WITHOUT_COBRA = [
  { label: "Primary business address" },
  { label: "Current coverage" },
  { label: "Current team" },
  { label: "Current health insurance" },
];

const STEPS_WITH_COBRA = [
  { label: "Primary business address" },
  { label: "Current coverage" },
  { label: "Current team" },
  { label: "Current health insurance" },
  { label: "COBRA partcipants" },
];

const STEPS_WITHOUT_COBRA_WITH_CORE_APP = [
  { label: "Current coverage" },
  { label: "Employee and dependents" },
  { label: "Upload documents" },
];

const STEPS_WITH_COBRA_WITH_CORE_APP = [
  { label: "Current coverage" },
  { label: "Employee and dependents" },
  { label: "Upload documents" },
  { label: "COBRA partcipants" },
];

const STEPS_WITH_CORE_APP_NOT_INTERESTED_HI = [
  { label: "Employee and dependents" },
];

const PAGE_TITLE = "Check out your health insurance options";

const HEALTH_APP_STATUS_CONTENT = {
  pageTitle: "You did it!",
  pageHeadingText: "",
  footerButtonText: "Back to Dashboard",
  urlText: "Return to Dashboard",
  url: getCWRedirectUrl("/onboarding_checklist"),
};

const WC_APP_SUBMITTED_BANNER_TEXT =
  "Your workers’ compensation application was successfully submitted. We’ll review it and reach out if we need any additional info.";

export {
  STEPS_WITHOUT_COBRA,
  STEPS_WITH_COBRA,
  PAGE_TITLE,
  HEALTH_APP_STATUS_CONTENT,
  WC_APP_SUBMITTED_BANNER_TEXT,
  STEPS_WITHOUT_COBRA_WITH_CORE_APP,
  STEPS_WITH_COBRA_WITH_CORE_APP,
  STEPS_WITH_CORE_APP_NOT_INTERESTED_HI,
};
